import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Heading,
  useTheme,
  useColorModeValue,
  Flex,
  Badge,
  Icon,
  Spinner,
  TableContainer,
  Text,
} from "@chakra-ui/react"
import { FaBoxOpen } from "react-icons/fa"
import axios from "axios";

const Top10B = ({ supplier, retailer }) => {
  const theme = useTheme();
  const [data, setData] = useState({ thead: [], tbody: [] });
  const [loading, setLoading] = useState(true);

  const cardBg = useColorModeValue("white", "gray.800")
  const borderColor = useColorModeValue("gray.200", "gray.700")
  const headerBg = useColorModeValue("gray.100", "gray.700")
  const headingBg = useColorModeValue("primary1", "darkPrimary1")
  const headingColor = useColorModeValue("white", "white")
  const hoverBg = useColorModeValue("gray.50", "gray.700")
  const accentColor = useColorModeValue("secondary1", "green.300")
  const highlightColor = useColorModeValue("secondary1", "green.300")

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       const res = await axios.post(`${process.env.REACT_APP_API_URL}/rep_sales/top10_2`, {
  //         supplier,
  //         retailer,
  //         userid: localStorage.getItem("userid"),
  //       });
  //       setData(res.data.data);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching data", error);
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [supplier, retailer]);

  useEffect(() => {
      const controller = new AbortController();
      const fetchData = async () => {
        setLoading(true);
        try {
          const res = await axios.post(
            `${process.env.REACT_APP_API_URL}/rep_sales/top10_2`,
            { supplier, retailer, userid: localStorage.getItem("userid") },
            { signal: controller.signal }
          );
          setData(res.data.data);
        } catch (err) {
          if (!axios.isCancel(err)) console.error("Error fetching data", err);
        } finally {
          if (!controller.signal.aborted) setLoading(false);
        }
      };
      fetchData();
      return () => controller.abort();
     }, [supplier, retailer]);

        const getBadgeColorScheme = (index) => {
    const colorSchemes = [
      "orange", // 1st
      "orange", // 2nd
      "orange", // 3rd
      "orange", // 4th
      "orange", // 5th
      "orange", // 6th
      "orange", // 7th
      "orange", // 8th
      "orange", // 9th
      "orange", // 10th
    ]
    return colorSchemes[index] || "gray"
  }




  return (
    <Box
      borderRadius="md"
      overflow="hidden"
      boxShadow="sm"
      bg={cardBg}
      borderWidth="1px"
      borderColor={borderColor}
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <Flex bg={headingBg} color={headingColor} p={3} alignItems="center" justifyContent="space-between">
        <Flex alignItems="center">
          <Icon as={FaBoxOpen} mr={2} />
          {/* <Heading size="sm">Highest SOH Value</Heading> */}
        </Flex>
        <Badge colorScheme="orange" variant="solid" borderRadius="full" px={2}>
          Stock Value
        </Badge>
      </Flex>

      {loading ? (
        <Box textAlign="center" py={8}>
          <Spinner size="lg" thickness="3px" speed="0.65s" color={highlightColor} />
          <Text mt={3} fontWeight="medium" fontSize="sm">
            Loading stock data...
          </Text>
        </Box>
      ) : (
        <TableContainer overflowY="auto" flex="1" className="custom-scrollbar">
          <Table variant="simple" size="sm" className="top10-table">
            <Thead bg={headerBg} position="sticky" top={0} zIndex={1}>
              {data.thead.map((row, rowIndex) => (
                <Tr key={rowIndex}>
                  {row.map((col, colIndex) => {
                    const colContent = Array.isArray(col) ? col[0] : col
                    const colSpan = col[1]?.value || 1

                    return (
                      <Th
                        key={colIndex}
                        colSpan={colSpan}
                        py={2}
                        px={3}
                        fontSize="xs"
                        textTransform="uppercase"
                        letterSpacing="wider"
                        fontWeight="semibold"
                        color="gray.600"
                        _dark={{ color: "gray.300" }}
                        borderBottom="2px"
                        borderColor={borderColor}
                        textAlign={colIndex > 0 ? "right" : "left"}
                      >
                        {colContent}
                      </Th>
                    )
                  })}
                </Tr>
              ))}
            </Thead>
            <Tbody>
              {data.tbody.map((row, rowIndex) => (
                <Tr
                  key={rowIndex}
                  _hover={{ bg: hoverBg }}
                  transition="background-color 0.2s"
                  position="relative"
                  borderLeft={rowIndex < 3 ? "2px solid" : "none"}
                  borderLeftColor={rowIndex < 3 ? accentColor : "transparent"}
                >
                  {row.map((col, colIndex) => {
                    const colContent = Array.isArray(col) ? col[0] : col
                    const isNumeric = colIndex > 0 && !isNaN(Number.parseFloat(colContent))

                    return (
                      <Td
                        key={colIndex}
                        py={2}
                        px={3}
                        fontSize="xs"
                        borderBottom="1px"
                        borderColor={borderColor}
                        textAlign={colIndex > 0 ? "right" : "left"}
                        fontWeight={"normal"}
                        color={"black"}
                        isNumeric={isNumeric}
                      >
                        {colIndex === 0 && (
                          <Badge
                            colorScheme={getBadgeColorScheme(rowIndex)}
                            mr={2}
                            fontSize="9px"
                            borderRadius="full"
                            variant={"solid"}
                          >
                            #{rowIndex + 1}
                          </Badge>
                        )}
                        {colContent}
                      </Td>
                    )
                  })}
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      )}
    </Box>
  )
};

export default Top10B;
